export default class ListUtils {
  static loadItemsData (instance, config) {
    instance.loaded = false;
    instance.loadError = false;

    instance.$http.post(config.endpoint, config.params).then(response => {
      // Filter out null/undefined items to prevent vnode errors
      const data = (response.data.data || []).filter(item => item != null);
      instance[config.listField] = data;
      instance.loaded = true;

      if (config.pagination) {
        instance.paginationMetaData = response.data.meta || null;
      }
    }).catch(error => {
      console.log(error);
      instance.loadError = true;
    });
  }

  static removeItem (instance, config) {
    instance.$swal({
      title: config.confirmTitle,
      text: config.confirmText,
      showCancelButton: true,
      confirmButtonText: config.confirmButtonText || 'Tak, usuń',
      cancelButtonText: 'Anuluj',
      buttonsStyling: true
    }).then((result) => {
      if (result.value) {
        instance.$http.post(config.endpointBase + config.id).then(response => {
          if (response.data.success) {
            instance.$swal({
              title: config.successTitle,
              html: config.successText,
              icon: 'success',
              confirmButtonText: 'OK',
              buttonsStyling: true
            }).then(() => {
              config.successAction();
            }).catch((errors) => {
              console.log(errors);
            });
          } else {
            if (config.failAction) {
              config.failAction();
            }

            instance.$swal({
              title: config.errorTitle,
              html: config.errorText,
              icon: 'error',
              confirmButtonText: 'OK',
              buttonsStyling: true
            });
          }
        }).catch(error => {
          console.log(error);

          if (config.failAction) {
            config.failAction();
          }

          instance.$swal({
            title: config.errorTitle,
            html: config.errorText,
            icon: 'error',
            confirmButtonText: 'OK',
            buttonsStyling: true
          });
        });
      } else {
        config.cancelAction();
      }
    });
  }
}
